import * as Sentry from "@sentry/react"
import { TanStackDevtools } from "@tanstack/react-devtools"
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"
import { createRootRoute, Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools"
import { ReloadPrompt } from "../components/ReloadPrompt"
import RestTimer from "../components/RestTimer"
import { Toaster as Sonner } from "../components/ui/sonner"
import { Toaster } from "../components/ui/toaster"
import { TooltipProvider } from "../components/ui/tooltip"
import { AuthProvider } from "../lib/auth/AuthContext"

export const Route = createRootRoute({
  component: RootComponent,
})

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () => {
      console.log("Used to invalidate queries, but that became far to slow!")
    },
    onError: (error, _variables, _context, _mutation) => {
      Sentry.captureException(error)
      console.error("Mutation error:", JSON.stringify(error, null, 2))
    },
  }),

  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 30, // 30 minutes
    },
  },
})

function RootComponent() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <TanStackDevtools
          config={{
            position: "bottom-left",
          }}
          plugins={[
            {
              name: "TanStack Query",
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: "TanStack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <ReloadPrompt />
          <AuthProvider>
            <Outlet />
          </AuthProvider>
          <RestTimer />
        </TooltipProvider>
      </QueryClientProvider>
    </>
  )
}
